import type { HintMeta } from 'types/hint';

const DEFAULT_DELAY = 2500;

export const HAS_ADDED_WIDGET_TO_REPORT = 'has_added_widget_to_report';
export const HAS_FILTERED_REPORTS = 'has_filtered_reports';
export const HAS_SEEN_CAN_REORDER = 'has_seen_can_reorder';

export const reportsHints = [
  HAS_ADDED_WIDGET_TO_REPORT,
  HAS_FILTERED_REPORTS,
  HAS_SEEN_CAN_REORDER,
] as const;

export type ReportsHint = (typeof reportsHints)[number];

export const reportsHintsMeta: Pick<HintMeta, ReportsHint> = {
  [HAS_ADDED_WIDGET_TO_REPORT]: {
    name: 'Add more charts',
    description: 'Customize reports with graphs of the data you care about',
    delay: DEFAULT_DELAY,
  },
  [HAS_FILTERED_REPORTS]: {
    name: 'Filter your report',
    description: 'Deep-dive into your data by selecting specific people, projects and tags!',
    delay: DEFAULT_DELAY,
  },
  [HAS_SEEN_CAN_REORDER]: {
    name: 'Change column order',
    description:
      'Head to Workplace Settings to change the column order for report exports in Excel (Projects tab) and CSV formats.',
  },
};
